import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

import { layer } from './lib/main';

export { defaultErrorHandler } from './lib/defaultErrorHandler';
export type { IEvent } from './types';
export type { IRequestConfig } from './types';

export const init = layer.init.bind(layer);
export const push = layer.push.bind(layer);

if (isClientSide()) {
    window.campaignLayer = layer;
}
